import React, { useMemo } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

export const FactoryRouter = ({ components }) => {
  const { search } = useLocation();
  const defaultRedirectComponentPath = useMemo(
    () =>
      `${
        (components.find((item) => item.defaultRedirectComponent) || components[0]).path
      }${search}`,
    [search]
  );

  return useMemo(
    () => (
      <Routes>
        {components.map(({ path, element }) => {
          return <Route exact key={path} path={path} element={element} />;
        })}
        <Route exact path='*' element={<Navigate to={defaultRedirectComponentPath} />} />
      </Routes>
    ),
    [components, defaultRedirectComponentPath]
  );
};
